// src/MyComponent.js
import React, { Component } from 'react';
import './NavStyle.css'
import logo from '../../assets/Images/last_logo_whit.png';
import whiteTextLAST from '../../assets/Images/borderlogolast_bg.png';
import boxbgLASTlogo from  '../../assets/Images/boxbgLASTlogo.png';
import hamburger from '../../assets/Images/hamburger.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { BrowserRouter as Router, Route, Switch, NavLink } from 'react-router-dom';

export class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showNavbar: false,
    };
  }

  handleShowNavbar = () => {
    this.setState((prevState) => ({ showNavbar: !prevState.showNavbar }));
  };

  render() {
    const { showNavbar } = this.state;

    return (
      <nav className="navbar">
        <div className="container">
          <div className="log">
           
         <Logo/>
           
          </div>
          <div className="menu-icon" onClick={this.handleShowNavbar}>
            <Hamburger />
          </div>
          
          <div className={`nav-elements ${showNavbar && 'active'}`}>
           
            <ul>
              <li>
                <NavLink to="/" exact>Home</NavLink>
              </li>
              {/* <li>
                <NavLink to="/blogs">Blogs</NavLink>
              </li> */}
              <li>
                <NavLink to="/products">Products</NavLink>
              </li>
              <li>
                <NavLink to="/About">About</NavLink>
              </li>
              {/* <li>
                <NavLink to="/contact">Contact</NavLink>
              </li> */}
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

const Home = () => <h2>You are in the Home</h2>;
const Blogs = () => <h2>You are in the Blogs</h2>;
const Projects = () => <h2>You are in the Projects</h2>;
const About = () => <h2>You are in the About</h2>;
const Contact = () => <h2>You are in the Contact</h2>;

const Hamburger = () => (
  // <img src={hamburger} />
  
  // <svg xmlns="http://www.w3.org/2000/svg" width="52" height="24" viewBox="0 0 52 24">
  //   <g id="Group_9" data-name="Group 9" transform="translate(-294 -47)">
  //     <rect id="Rectangle_3" data-name="Rectangle 3" width="42" height="4" rx="2" transform="translate(304 47)" fill="#574c4c" />
  //     <rect id="Rectangle_5" data-name="Rectangle 5" width="42" height="4" rx="2" transform="translate(304 67)" fill="#574c4c" />
  //     <rect id="Rectangle_4" data-name="Rectangle 4" width="52" height="4" rx="2" transform="translate(294 57)" fill="#574c4c" />
  //   </g>
  // </svg>

<FontAwesomeIcon icon={faBars} style={{ color: '#eceff3',height:'30px'}} />

);

const Logo = () => (
    <img className="logo" src={whiteTextLAST} alt="Logo" /> 
);

// const App = () => {
//   return (
//     <Router>
//       <Navbar />
//       <Switch>
//         <Route exact path="/" component={Home} />
//         <Route path="/blogs" component={Blogs} />
//         <Route path="/projects" component={Projects} />
//         <Route path="/about" component={About} />
//         <Route path="/contact" component={Contact} />
//       </Switch>
//     </Router>
//   );
// };

export {Logo} ;
